import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Terms from "../../components/AboutUs/Terms"

const TermsConditions = () => {
  return (
    <Layout>
      <SEO title="Terms of use" />
      <Terms />
    </Layout>
  )
}

export default TermsConditions